'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["addConditionDisabledTooltip", "className", "disabled", "filterFamilyAndButtonTooltip", "isXoEnabled", "type"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UITooltipContent from 'UIComponents/tooltip/UITooltipContent';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class FilterEditorOperatorCreateButton extends PureComponent {
  constructor(props) {
    super(props);
    this.renderTooltipContent = this.renderTooltipContent.bind(this);
  }
  renderTooltipContent() {
    const {
      addConditionDisabledTooltip
    } = this.props;
    return /*#__PURE__*/_jsx(UITooltipContent, {
      children: addConditionDisabledTooltip
    });
  }
  render() {
    const _this$props = this.props,
      {
        addConditionDisabledTooltip,
        className,
        disabled,
        filterFamilyAndButtonTooltip,
        isXoEnabled,
        type
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    if (!isXoEnabled) {
      return /*#__PURE__*/_jsxs(UIButton, Object.assign({
        block: true,
        className: classNames(className, 'p-bottom-3'),
        "data-onboarding": "filter-editor-create-button",
        "data-selenium-test": "FilterEditorOperatorCreateButton-filters2",
        disabled: disabled,
        use: "link"
      }, rest, {
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "add"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFilters.FilterEditor.add"
        }, "text")]
      }));
    }
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(UITooltip, {
        Content: this.renderTooltipContent,
        disabled: !disabled || !addConditionDisabledTooltip,
        placement: "right",
        children: /*#__PURE__*/_jsx(UIButton, Object.assign({}, rest, {
          block: !isXoEnabled,
          className: className,
          "data-selenium-test": "FilterEditorOperatorCreateButton-xofilters",
          disabled: disabled,
          size: "extra-small",
          use: "tertiary-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `customerDataFilters.FilterEditorOperatorDisplayList.${type}`
          })
        }))
      }), filterFamilyAndButtonTooltip && !disabled && /*#__PURE__*/_jsx(UIHelpIcon, {
        className: "display-flex-inline p-x-2",
        title: filterFamilyAndButtonTooltip,
        tooltipPlacement: "right"
      })]
    });
  }
}
FilterEditorOperatorCreateButton.propTypes = {
  addConditionDisabledTooltip: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  filterFamilyAndButtonTooltip: PropTypes.node,
  isXoEnabled: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(['and', 'or'])
};
export default FilterEditorOperatorCreateButton;